/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OverrideJustificationArtefact } from './OverrideJustificationArtefact';
import {
  OverrideJustificationArtefactFromJSON,
  OverrideJustificationArtefactFromJSONTyped,
  OverrideJustificationArtefactToJSON,
} from './OverrideJustificationArtefact';

/**
 *
 * @export
 * @interface OverrideJustification
 */
export interface OverrideJustification {
  /**
   *
   * @type {number}
   * @memberof OverrideJustification
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof OverrideJustification
   */
  description?: string | null;
  /**
   *
   * @type {Array<OverrideJustificationArtefact>}
   * @memberof OverrideJustification
   */
  readonly artefacts: Array<OverrideJustificationArtefact>;
}

/**
 * Check if a given object implements the OverrideJustification interface.
 */
export function instanceOfOverrideJustification(value: object): value is OverrideJustification {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('artefacts' in value) || value['artefacts'] === undefined) return false;
  return true;
}

export function OverrideJustificationFromJSON(json: any): OverrideJustification {
  return OverrideJustificationFromJSONTyped(json, false);
}

export function OverrideJustificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverrideJustification {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    description: json['description'] == null ? undefined : json['description'],
    artefacts: (json['artefacts'] as Array<any>).map(OverrideJustificationArtefactFromJSON),
  };
}

export function OverrideJustificationToJSON(value?: Omit<OverrideJustification, 'id' | 'artefacts'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    description: value['description'],
  };
}
